import React, { useState } from 'react';
import './CustomInput.css';

export const CustomInput = ({
    label,
    error,
    leftIcon,
    rightIcon,
    onRightIconClick,
    isPassword = false,
    disabled = false,
    containerStyle = {},
    className = '',
    ...props
}) => {
    const [isFocused, setIsFocused] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const getBorderColor = () => {
        if (error) return '#ef4444';
        if (isFocused) return '#2563eb';
        return 'rgba(255, 255, 255, 0.05)';
    };

    return (
        <div className={`custom-input-container ${className}`} style={containerStyle}>
            {label && <label className="input-label">{label}</label>}

            <div
                className={`input-wrapper ${isFocused ? 'focused' : ''} ${error ? 'error' : ''} ${disabled ? 'disabled' : ''}`}
                style={{ borderColor: getBorderColor() }}
            >
                {leftIcon && (
                    <span
                        className="material-icons input-icon left"
                        style={{ color: isFocused ? '#2563eb' : '#475569' }}
                    >
                        {leftIcon}
                    </span>
                )}

                <input
                    {...props}
                    type={isPassword && !showPassword ? 'password' : props.type || 'text'}
                    className="custom-input"
                    disabled={disabled}
                    readOnly={disabled}
                    onFocus={(e) => {
                        if (!disabled) {
                            setIsFocused(true);
                            props.onFocus?.(e);
                        }
                    }}
                    onBlur={(e) => {
                        setIsFocused(false);
                        props.onBlur?.(e);
                    }}
                />

                {isPassword && (
                    <button
                        type="button"
                        className="icon-button"
                        onClick={() => setShowPassword(!showPassword)}
                    >
                        <span className="material-icons input-icon right">
                            {showPassword ? 'visibility_off' : 'visibility'}
                        </span>
                    </button>
                )}

                {rightIcon && !isPassword && (
                    <button
                        type="button"
                        className="icon-button"
                        onClick={onRightIconClick}
                        disabled={!onRightIconClick}
                    >
                        <span className="material-icons input-icon right">{rightIcon}</span>
                    </button>
                )}
            </div>

            {error && <span className="input-error">{error}</span>}
        </div>
    );
};

export default CustomInput;
